import { lazyWithPreload } from 'helpers/lazyWithPreload'

export const Recommendations = lazyWithPreload(
  () => import('./Recommendations'),
)
